import { TableListState, TableListResponse } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getAllTables } from './tablelist.services';

export const initialState: TableListState = {
    data: {} as TableListResponse,
    status: "loading",
    error: {}
}

export const TableSlice = createSlice({
    name: 'tables',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllTables.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getAllTables.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getAllTables.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const TableReducers = TableSlice.reducer